/*
 * @Descripttion:
 * @version:
 * @Author: yql
 * @Date: 2019-12-13 18:49:41
 * @LastEditors  : yql
 * @LastEditTime : 2019-12-25 11:21:46
 */

import request from "@/utils/request";

//发送登录验证码
export function sendVerifyCode(data) {
  return request({
    url: "/gateway/prop/h5/sendVerifyCode",
    method: "post",
    data
  });
}

//登录
export function login(data) {
  return request({
    url: "/gateway/prop/h5/login",
    method: "post",
    data
  });
}

//微信授权
export function isWechatClient(data) {
  return request({
    url: "/gateway/prop/wx/isWechatClient",
    method: "post",
    data
  });
}
//账号密码登录
export function loginPwd(data) {
  return request({
    url: "/gateway/prop/h5/loginPwd",
    method: "post",
    data
  });
}

//忘记密码发验证码
export function resetPwdSendSms(data) {
  return request({
    url: "/gateway/prop/h5/resetPwdSendSms",
    method: "post",
    data
  });
}
//设置密码
export function editPwd(data) {
  return request({
    url: "/gateway/prop/h5/user/editPwd",
    method: "post",
    data
  });
}
//忘记密码设置
export function resetPwd(data) {
  return request({
    url: "/gateway/prop/h5/user/resetPwd",
    method: "post",
    data
  });
}
export function authorizationLogin(data) {
  return request({
    url: "/gateway/prop/wx/authorizationLogin",
    method: "get",
    params: data
  });
}
export function wxBindSendSms(data) {
  return request({
    url: "/gateway/prop/h5/wxBindSendSms",
    method: "post",
    data
  });
}
export function wxBind(data) {
  return request({
    url: "/gateway/prop/h5/user/wxBind",
    method: "post",
    data
  });
}
export function wxUnBind(data) {
  return request({
    url: "/gateway/prop/h5/user/wxUnBind",
    method: "post",
    data
  });
}

export function modifyPwd(data) {
  return request({
    url: "/gateway/prop/h5/user/modifyPwd",
    method: "post",
    data
  });
}
export function loginWx(data) {
  return request({
    url: "/gateway/prop/h5/loginWx",
    method: "post",
    data
  });
}
